import React from 'react';
import FlowEditor from './FlowEditor';

export default function DuplicateFlow(props) {
    return <FlowEditor {...props} mode="duplicate"/>;
}
